import React from 'react'

const Copywrite = () => {
    return (
        <div className='w-full flex items-center justify-center flex-col mt-6 space-y-4'>
            <p className="text-[#434343] font-light font-['Myriad_Pro']">            
            &copy; {new Date().getFullYear()} Respoclear.net. All Rights Reserved.

                       </p>

            <footer className=" text-center text-sm text-gray-700">
                <nav className="flex flex-col sm:flex-row sm:justify-center space-y-2 sm:space-y-0 sm:space-x-6 font-['Myriad_Pro']">
                    <a href="/privacy" className="hover:underline">Privacy Policy </a>
                    <a href="/terms" className="hover:underline">Terms </a>
                    <a href="/contact" className="hover:underline">Contact</a>
                    <a href="/returns" className="hover:underline">Refunds & Returns</a>
                    <a href="/disclaimer" className="hover:underline">Disclaimer</a>
                </nav>
            </footer>
        </div>
    )
}

export default Copywrite
